'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendVisitorEmailAddressSucceeded = exports.sendVisitorEmailAddressFailed = exports.sendVisitorEmailAddressRequested = undefined;
exports.sendVisitorEmailAddress = sendVisitorEmailAddress;

var _reduxActions = require('redux-actions');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _VisitorApiClient = require('conversations-visitor-ui/VisitorApiClient');

var VisitorApiClient = _interopRequireWildcard(_VisitorApiClient);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sendVisitorEmailAddressRequested = exports.sendVisitorEmailAddressRequested = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS, function (email) {
  return { email: email };
});

var sendVisitorEmailAddressFailed = exports.sendVisitorEmailAddressFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS_FAILED, function (error) {
  return { error: error };
});

var sendVisitorEmailAddressSucceeded = exports.sendVisitorEmailAddressSucceeded = (0, _reduxActions.createAction)(_ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED, function (email) {
  return { email: email };
});

function sendVisitorEmailAddress(email) {
  return function (dispatch, getState) {
    dispatch(sendVisitorEmailAddressRequested(email));

    var successCb = function successCb() {
      dispatch(sendVisitorEmailAddressSucceeded(email));
    };

    var failureCb = function failureCb(error) {
      dispatch(sendVisitorEmailAddressFailed(error));
    };

    VisitorApiClient.sendVisitorEmailAddress({
      email: email,
      sessionId: (0, _widgetDataSelectors.getSessionId)(getState())
    }).then(successCb, failureCb).done();
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/VisitorEmailAddressActions.js
// module id = 191
// module chunks = 0 1